
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/notes/[slug]",
      function () {
        return require("private-next-pages/notes/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/notes/[slug]"])
      });
    }
  